export default "__VITE_ASSET__7ffa1d60__"